import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT
} from "../actions/auth";
import auth from "../../services/auth.js";

const state = {
  token:
    JSON.parse(localStorage.getItem("access_token")) == null
      ? ""
      : JSON.parse(localStorage.getItem("access_token")).token,
  status: "",
  exp:
    JSON.parse(localStorage.getItem("access_token")) == null
      ? ""
      : JSON.parse(localStorage.getItem("access_token")).exp,
  hasLoadedOnce: false
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  tokenExp: state => !!(Date.now() <= state.exp)
};

const actions = {
  [AUTH_REQUEST]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);

      auth
        .request(data)
        .then(response => {
          var exp = Date.now() + 300000;

          let token =
            '{ "token" : "' +
            response.headers.authorization +
            '", "exp": "' +
            exp +
            '" }';

          localStorage.setItem("username", response.data.username);

          localStorage.setItem("access_token", token);

          commit(AUTH_SUCCESS, response);
          resolve(response);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem("access_token");
          reject(err);
        });
    });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem("access_token");
      localStorage.removeItem("username");
      resolve();
    });
  }
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = "loading";
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = "success";
    state.token = resp.headers.authorization;
    state.exp = Date.now() + 3600000;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: state => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: state => {
    state.token = "";
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
